import usFlag from './US.svg'
import canadaFlag from './CA.svg'
import { LANGUAGES } from 'app/consts'

export const flags = {
  [LANGUAGES.EN_US]: usFlag,
  [LANGUAGES.FR_CA]: canadaFlag,
}
